function phoneIsValid(phone: string | null | undefined): boolean {
  return phone != null && phone.length === 11 && phone[0] === '7' && phone[1] === '9' && !Number.isNaN(Number(phone));
}

export default phoneIsValid;
